var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"uppercase text-sm tracking-widest",class:_vm.status_class},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.status_text))+"\n\n    "),_c('i',{staticClass:"ml-1",class:_vm.status_icon,attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }